export const selectNavigator = (state) => state.navigator;
export const selectMapRef = (state) => state.mapRef;
export const selectMeasuringMode = (state) => state.measuringMode;
export const selectEvent = (state) => state.event;
export const selectTracker = (state) => state.tracker;
export const selectBreadcrumb = (state) => state.breadcrumb;
export const selectBounds = (state) => state.bounds;
